<template>
  <div id="app" ref="app">
    <h3>组件测试</h3>

    <div class="PriceTagContainer">
			<div>
				<h5>类型</h5>
				<Tab :itemList="priceTagType" v-model="priceTagTypeC"></Tab>
			</div>
			<div>
				<h5>主题</h5>
				<Tab :itemList="priceTagTheme" v-model="priceTagThemeC"></Tab>
			</div>
			<div>
				<h5>平台</h5>
				<div class="priceTagPlatform">
					<div :class="{ cur: priceTagPlatformC == i }" v-for="i in priceTagPlatform" :key="i"
						@click="priceTagPlatformC = i">{{ i }}</div>
				</div>
				<!-- <Tab :itemList="priceTagPlatform" v-model="priceTagPlatformC"></Tab> -->
			</div>
			<div>
				<h5>史低标签</h5>
				<Tab :itemList="priceTagLowHistoryTag" v-model="priceTagLowHistoryTagC"></Tab>
			</div>
			<div>
				<div style="display: flex;align-items: center;justify-content: center;">
					<label>折扣百分比</label>
					<input type="text" v-model="priceTagDiscountRatio">
				</div>
				<div style="display: flex;align-items: center;justify-content: center;">
					<label>最大宽度</label>
					<input type="text" v-model="priceTagMaxWidth" @input="handleInput">
				</div>
				<div style="display: flex;align-items: center;justify-content: center;">
					<label>当前价格</label>
					<input type="text" v-model="priceTagCurrentPrice">
				</div>
				<div style="display: flex;align-items: center;justify-content: center;">
					<label>折扣价格</label>
					<input type="text" v-model="priceTagDiscountedPrice">
				</div>
			</div>
			<div>
				<PriceTag v-if="showPriceTag" :type="priceTagTypeC" :theme="priceTagThemeC" :maxWidth="currentWidth"
					:platform="priceTagPlatformC" :currentPrice="priceTagCurrentPrice != `` ? Math.round(Number(priceTagCurrentPrice)) : ``"
					:discountedPrice="Math.round(Number(priceTagDiscountedPrice))"
					:discountRatio="priceTagDiscountRatio > 0 ?`-${Math.round(Number(priceTagDiscountRatio))}%`: ``" :lowHistoryTag="priceTagLowHistoryTagC">
				</PriceTag>
			</div>

		</div>

    <div class="controls">
      <div class="control-group">
        <input type="checkbox" v-model="isFreeTheme" id="option1">
        <label for="option1">是否开启自定义主题</label>
      </div>

      <div class="control-group">
        <input type="checkbox" v-model="closeOnClickOutside" id="option2">
        <label for="option2">是否允许点击外部区域关闭</label>
      </div>

      <div class="control-group">
        <input type="text" v-model="direction" placeholder="方向(bottom/top)">
        <div>方向(默认bottom): bottom or top</div>
      </div>

      <div class="control-group" v-if="isFreeTheme">
        <input type="text" v-model="containerBgColor" placeholder="背景色">
        <div>背景色</div>
      </div>

      <div class="control-group" v-if="isFreeTheme">
        <input type="text" v-model="textColor" placeholder="字体颜色">
        <div>字体颜色</div>
      </div>

      <div class="control-group">
        <input type="text" v-model="timeout" placeholder="延迟关闭时间">
        <div>延迟关闭(默认0)</div>
      </div>

      <div class="control-group">
        <p>自定义内容</p>
        <input type="text" v-model="customContent" placeholder="提示内容">
      </div>
    </div>

    <div class="tips-buttons">
      <Tab :itemList="tipsItemList" v-model="tipsActive"></Tab>

      <div class="tips" :class="[tipsActive]">
        <button @click="showTips">显示Tips提示</button>
      </div>
    </div>




    <div style="display: flex;align-items: center;justify-content: space-around;margin-bottom: 10px;">
      <input type="text" placeholder="输入测试tabItem" v-model="inputValue" @keyup.enter="addItem">
      <button @click="addItem">添加</button>
    </div>

    <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;">
      <h5>禁用</h5>
      <div style="cursor: pointer;margin: 0 5px;" :class="{ 'disable-item': disableItems.includes(item) }"
        v-for="(item, index) in itemList" :key="index" @click="setDisableItems(item)">{{ item }}</div>
    </div>
    <div style="display: flex;align-items: center;justify-content: center;">
      <h5>主题</h5>
      <div style="cursor: pointer;margin: 0 5px;" :class="{ 'disable-item': isFreeTheme }"
        @click="isFreeTheme = !isFreeTheme">
        {{ isFreeTheme ? '跟随系统' : '自定义主题' }}
      </div>
    </div>
    <div style="padding:20px 0;">
      <Tab :itemList="itemList" v-model="active" :isFreeTheme="isFreeTheme" :disableItems="disableItems"></Tab>
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  data() {
    return {
      inputValue: "",
      itemList: ["15天", "30天", "1年"],
      disableItems: ["30天"],
      active: "15天",
      isFreeTheme: false,
      closeOnClickOutside: true,
      direction: 'bottom',
      containerBgColor: '#11228a',
      textColor: '#fff',
      timeout: 0,
      tipsItemList: ['left', 'center', 'right'],
      tipsActive: 'center',
      customContent: '这是提示内容',
      // 选项列表
      priceTagType: ["A", "B"],
      priceTagTheme: ["A", "B"],
      priceTagPlatform: [
        "gamerskystore", "android", "epic", "fenghuang", 
        "gog", "ios", "ns", "origin", "pc", "phone", 
        "ps", "steam", "ubi", "xbox"
      ],
      priceTagLowHistoryTag: ["史低", "新史低", "超史低", ""],
      
      // 当前选中值
      priceTagTypeC: "A",
      priceTagThemeC: "A",
      priceTagPlatformC: "gamerskystore",
      priceTagLowHistoryTagC: "史低",
      
      // 价格相关
      priceTagDiscountRatio: "80",
      priceTagMaxWidth: "0",
      priceTagCurrentPrice: "500",
      priceTagDiscountedPrice: "1000",
      
      // 宽度控制
      widthTimeout: null,
      currentWidth: 0,
      
      // 显示控制
      showPriceTag: true
    }
  },
  watch: {
    isFreeTheme(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (newVal) {
        this.isFreeTheme = true;
        this.$refs.app.style.background = "#71118a";
      } else {
        this.isFreeTheme = false;
        this.$refs.app.style.background = "transparent";
      }
    },
  },
  mounted() {
    // alert(location.href)
  },
  methods: {
    handleInput() {
      this.showPriceTag = false;
      clearTimeout(this.widthTimeout);
      this.widthTimeout = setTimeout(() => {
        this.currentWidth = parseInt(this.priceTagMaxWidth);
        this.showPriceTag = true;
      }, 500);
    },
    showTips(event) {
      this.$tips(event.target, {
        content: this.customContent,
        direction: this.direction,
        containerBgColor: this.containerBgColor,
        textColor: this.textColor,
        timeout: Number(this.timeout),
        isFreeTheme: this.isFreeTheme,
        closeOnClickOutside: this.closeOnClickOutside
      });
    },
    addItem() {
      this.itemList.push(this.inputValue);
      this.inputValue = "";
    },
    setDisableItems(item) {
      if (this.disableItems.includes(item)) {
        this.disableItems = this.disableItems.filter((i) => i !== item);
      } else {
        this.disableItems.push(item);
      }
    }
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  min-height: 100vh;
  transition: all .3s;
}

.disable-item {
  color: red;
}


.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

.controls {
  margin-bottom: 30px;
}

.control-group {
  margin-bottom: 15px;
}

.tips-buttons {
  padding: 20px 0;
}

.tips {
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  margin-top: 20px;
}

.tips.left {
  justify-content: flex-start;
}

.tips.center {
  justify-content: center;
}

.tips.right {
  justify-content: flex-end;
}


.PriceTagContainer {
	&>div {
		display: flex;
		flex-direction: column;
		width: 100%;
		align-items: center;
		width: 100%;
		margin-bottom: 10px;
		padding: 0 16px;
		overflow: hidden;
		box-sizing: border-box;
	}
}

.priceTagPlatform {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-gap: 5px;
	width: 100%;

	div {
		background-color: #65676B;
		color: #fff;
		cursor: pointer;
		border-radius: 4px;
		font-size: 12px;
		height: 24px;
		line-height: 24px;

		&.cur {
			background-color: #0071E3;
		}
	}
}
</style>
